import React, { useState, useEffect, Fragment } from "react";
import { MaterialReactTable } from "material-react-table";
import { Breadcrumb, Col, Input, Label, Row } from "reactstrap";
import { Box, Button } from "@mui/material";
import { formattedDateOnly } from "../../../../src/utilities/formatedDate";
import GetButtons from "../../common/getButtons";
import convertToRupees from "../../../../src/utilities/convertToRupees";
import { getAllPartnershipListBYRoleWithoutPagination, SalesLedgerList } from "../../../api";
import GetExport from "../../common/getExport";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MscLedgerList } from "../../../api";

const MscLedger = () => {
    const [selectedBP, setSelectedBP] = useState();
    const [partners, setPartners] = useState([]);
    const [ledgerData, setLedgerData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    const [sorting, setSorting] = useState([{ "id": "model_id", "desc": true }]);
    const [yearRange, setYearRange] = useState([null, null]);
    // const [startYear, endYear] = yearRange;
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [columnFilters, setColumnFilters] = useState([]);
    const debouncedSetColumnFilters = debounce(setColumnFilters, 500); // 500 milliseconds debounce
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const currentYear = new Date().getFullYear();
    const [startYear, setStartYear] = useState(currentYear);
    const [endYear, setEndYear] = useState(currentYear);
    const [role, setRole] = useState(null);

    const [error, setError] = useState("");

    useEffect(() => {
        const roleData = JSON.parse(localStorage.getItem("ROLE"));
        const userData = JSON.parse(localStorage.getItem("user"));

        if (roleData) {
            setRole(roleData.key);          // set role key
        }
        if (userData) {
            setSelectedBP(userData.partnership_id); // set partnership_id for non-admin users
        }
    }, []);

    console.log("role", role);
    console.log("selectedBP", selectedBP);


    const handleStartYearChange = (date) => {
        if (date && date.getFullYear() > currentYear) {
            setError(`Start year cannot be greater than ${currentYear}.`);
            return;
        }
        setStartYear(date);

        if (endYear && date && endYear.getFullYear() < date.getFullYear()) {
            setError("End year cannot be earlier than start year.");
        } else {
            setError("");
        }
    };

    const handleEndYearChange = (date) => {
        if (date && date.getFullYear() > currentYear) {
            setError(`End year cannot be greater than ${currentYear}.`);
            return;
        }
        if (startYear && date && date.getFullYear() < startYear.getFullYear()) {
            setError("End year cannot be earlier than start year.");
            return;
        }
        setEndYear(date);
        setError("");
    };

    const fetchBussinessPartnerships = async () => {
        try {
            const response = await getAllPartnershipListBYRoleWithoutPagination();
            if (response.status === 200) {
                const res = response?.data?.result?.partnershipData;
                console.log("res1111", res);

                const partnershipOptions = []
                res.map((item) => {
                    const pcode = item?.partnership_code?.length > 15
                        ? item?.partnership_code?.slice(0, 15) + "..."
                        : item?.partnership_code

                    const obj = {
                        value: item.partnership_id,
                        label: `${item.name} (${pcode})`,
                        user_name: item?.user?.name || '',
                        is_active: item.is_active,
                        is_kyc_active: item.is_kyc_active,
                        wallet_closure_status: item.wallet_closure_status,
                        wallet_balance: item.user?.user_wallet?.amount || 0,
                        msc_percentage: item.commission_percent || 0,
                        partner_info: item || {},
                    }
                    if (obj.is_active && obj.is_active !== false && obj.is_kyc_active && obj.is_kyc_active !== false && obj.wallet_balance > 0) {
                        partnershipOptions.push(obj)
                    }
                });

                setPartners(partnershipOptions);

            }
        } catch (error) {
            console.error("Error fetching business partnerships", error);
            toast.error("Failed to load business partnerships.");
        }
    };

    const fetchLedgerData = async () => {
        try {

            const data = {
                "partnershipId": selectedBP,
                "dateRange": `${startYear || ""}-${endYear || ""}`,
                "page": pagination.pageIndex,
                "limit": pagination.pageSize,
                "filters": columnFilters,
                "sorting": sorting,
                "globalFilter": globalFilter,
            }
            console.log('Request Data for Ledger:', data);
            const response = await MscLedgerList(data);
            const ledgerData = await response.data?.result.data;
            console.log('Ledger Data:', ledgerData);
            setLedgerData(ledgerData || []);
            setCount(response?.data?.result?.pagination?.totalCount)

        } catch (error) {
            console.error('Error fetching ledger data:', error);
            toast.error("Failed to load ledger data.");
        }
    };

    // const viewAll = () => {
    //     fetchLedgerData();
    // };

    useEffect(() => {
        fetchBussinessPartnerships();
        // Only fetch if both partner and year range are selected
        if (selectedBP && startYear && endYear) {
            fetchLedgerData();
        }
    }, [pagination, selectedBP, startYear, endYear, columnFilters, sorting, globalFilter]);

    const financialColumns = [
        {
            accessorKey: "date",
            header: "Date",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{formattedDateOnly(row.original.created_at) || "N/A"}</span>
            ),
        },
        {
            accessorKey: "description",
            header: "Description",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{row.original.description || "N/A"}</span>
            ),
        },
        {
            accessorKey: "coaNumber",
            header: "COA Number",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{row.original.coaNumber || "N/A"}</span>
            ),
        },
        {
            accessorKey: "walletMode",
            header: "Wallet Mode",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{row.original.walletMode || "N/A"}</span>
            ),
        },
        {
            accessorKey: "bpCode",
            header: "BP Code",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{row.original.bpCode || "N/A"}</span>
            ),
        },
        {
            accessorKey: "bpName",
            header: "BP Name",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{row.original.bpName || "N/A"}</span>
            ),
        },
        {
            accessorKey: "mscInvoiceNumber",
            header: "MSC Invoice Number",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (<span>{row.original.mscInvoiceNumber || "N/A"}</span>
            ),
        },
        {
            accessorKey: "mscAmount",
            header: "MSC",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{convertToRupees(row.original.mscAmount) || "N/A"}</span>
            ),
        },
        {
            accessorKey: "tdsAmount",
            header: "TDS",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{convertToRupees(row.original.tdsAmount) || "N/A"}</span>
            ),
        },
        {
            accessorKey: "payableAmount",
            header: "Payable Amt",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{convertToRupees(row.original.payableAmount) || "N/A"}</span>
            ),
        },
        {
            accessorKey: "remainingAmount",
            header: "Remaining",
            filter: false,
            enableClickToCopy: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <span>{convertToRupees(row.original.remainingAmount) || "N/A"}</span>
            ),
        },
        {
            accessorKey: "balance",
            header: "Balance",
            Cell: ({ row }) => (
                <span>{convertToRupees(row.original.balance) || "N/A"}</span>
            ),
        },

    ];

    const exportedFinancialData = ledgerData.map((item) => ({
        Date: item.created_at ? formattedDateOnly(item.created_at) : "N/A",

        Description: item.description || "N/A",

        Wallet_Type: item.walletType || "N/A",

        BP_Code: item.bpCode || "N/A",

        BP_Name: item.bpName || "N/A",

        Invoice_Number: item.invoiceNumber || "N/A",

        COA_Number: item.coaNumber || "N/A",

        Receipt_Number: item.offlineReceiptNumber || "N/A",

        Payment_UTR: item.paymentUtr || "N/A",

        COA_Receivable: item.coaReceivable
            ? convertToRupees(item.coaReceivable, true)
            : "N/A",

        Gross_Receivable: item.grossReceivable
            ? convertToRupees(item.grossReceivable, true)
            : "N/A",

        MSC: item.mscAmount
            ? convertToRupees(item.mscAmount, true)
            : "N/A",

        TDS: item.tdsAmount
            ? convertToRupees(item.tdsAmount, true)
            : "N/A",

        Receipt: item.receiptAmount
            ? convertToRupees(item.receiptAmount, true)
            : "N/A",

        Net_Receivable: item.netReceivable
            ? convertToRupees(item.netReceivable, true)
            : "N/A",

        Remaining_Amount: item.remainingAmount
            ? convertToRupees(item.remainingAmount, true)
            : "N/A",

        Balance: item.balance
            ? convertToRupees(item.balance, true)
            : "N/A",

        // Reference: item.reference || "N/A",

        // Ledger_Event: item.ledgerEvent || "N/A",

        // Transaction_Type: item.transaction_type || "N/A",
    }));

    return (
        <Fragment>
            <Breadcrumb parent="Home" title="Ledger" />
            <div>
                <Row className="align-items-center">
                    {/* Business Partner Dropdown */}
                    {role !== "DEALERSHIP_MANAGER" && (
                        <Col sm="4" className="mb-3">
                            <Label>
                                Business Partner
                                <sup className="text-danger fs-5">*</sup>
                            </Label>
                            <Input
                                type="select"
                                name="partnership_id"
                                className="form-control"
                                value={selectedBP}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedBP(value);
                                    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
                                }}
                            >
                                <option value="">Select Partner</option>
                                {partners?.map((ele, index) => (
                                    <option key={index} value={ele.value}>
                                        {ele.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    )}

                    {/* <Col sm="4" className="mb-3">
                        <Label>
                            Business Partner
                            <sup className="text-danger fs-5">*</sup>
                        </Label>
                        <Input
                            type="select"
                            name="partnership_id"
                            className="form-control"
                            value={selectedBP}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSelectedBP(value);
                                setPagination((prev) => ({ ...prev, pageIndex: 0 }));
                            }}
                        >
                            <option value="">Select Partner</option>
                            {partners?.map((ele, index) => (
                                <option key={index} value={ele.value}>
                                    {ele.label}
                                </option>
                            ))}
                        </Input>
                    </Col> */}

                    {/* Year Range Picker */}
                    <Col sm="4" className="mb-3">
                        <Label>
                            Year Range <sup className="text-danger fs-5">*</sup>
                        </Label>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <DatePicker
                                selected={startYear ? new Date(startYear, 0, 1) : null}
                                onChange={handleStartYearChange}
                                showYearPicker
                                dateFormat="yyyy"
                                placeholderText="Start Year"
                                className="form-control"
                                maxDate={new Date(currentYear, 11, 31)} // start year must be <= current year
                            />
                            <span>–</span>
                            <DatePicker
                                selected={endYear ? new Date(endYear, 0, 1) : null}
                                onChange={handleEndYearChange}
                                showYearPicker
                                dateFormat="yyyy"
                                placeholderText="End Year"
                                className="form-control"
                                maxDate={new Date(currentYear, 11, 31)} // end year must be <= current year
                            />
                        </div>
                        {error && <small className="text-danger">{error}</small>}
                    </Col>

                </Row>

                {/* Ledger Table */}
                <MaterialReactTable
                    data={ledgerData || []}
                    columns={financialColumns || []}
                    enableGlobalFilter={false}
                    initialState={{ showColumnFilters: false, density: "compact" }}
                    positionToolbarAlertBanner="bottom"
                    defaultColumn={{
                        maxSize: 400,
                        minSize: 80,
                        size: 100,
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                        <Box
                            sx={{
                                display: "flex",
                                gap: "0.5rem",
                                p: "0.5rem",
                                flexWrap: "wrap",
                            }}
                        >
                            <GetButtons onClick={fetchLedgerData} type="refresh" />
                            <GetExport
                                columns={financialColumns}
                                exportedData={exportedFinancialData}
                                name="Document"
                            />
                        </Box>
                    )}
                    columnResizeMode="onChange"
                    manualFiltering
                    manualPagination
                    manualSorting
                    onColumnFiltersChange={debouncedSetColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    muiTableBodyProps={{
                        sx: {
                            "& td": {
                                paddingTop: "8px",
                                paddingBottom: "8px",
                            },
                        },
                    }}
                    rowCount={count}
                    state={{
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        sorting,
                        showLoadingOverlay: false,
                        showProgressBars: isLoading,
                    }}
                    enableFacetedValues={true}
                />
            </div>
        </Fragment>

        //v1
        // <Fragment>
        //     <Breadcrumb parent="Home" title="Ledger" />
        //     <div>
        //         <Row className="align-items-center">
        //             <Col sm="4" className="text-left mb-3">
        //                 <Label>{"Buisness Partner"}</Label><sup style={{ fontSize: "medium", top: 0 }} className="text-danger fs-1">*</sup>
        //                 <Input type="select"
        //                     name="partnership_id"
        //                     className="form-control"
        //                     defaultValue={""}
        //                     value={selectedBP}
        //                     // innerRef={register({ required: true })}
        //                     onChange={(e) => {
        //                         const value = e.target?.value;
        //                         setSelectedBP([value]);
        //                         // Immediately fetch with new BP filter
        //                         // Reset pagination to first page
        //                         setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        //                         // Use default or current filters as needed

        //                     }}
        //                 >
        //                     <option value="" >{"Select Partner"}</option>
        //                     {partners?.map((ele, index) =>
        //                         <option key={index} value={ele.value}>{ele.label}</option>)}
        //                 </Input>
        //             </Col>
        //             <Col sm="4" className="text-left mb-3   ">
        //                 <label>Year Range</label><sup style={{ fontSize: "medium", top: 0 }} className="text-danger fs-1">*</sup>
        //                 <DatePicker
        //                     selected={startYear}
        //                     onChange={(update) => {
        //                         const [start, end] = update;
        //                         setStartYear(start);
        //                         setEndYear(end);
        //                     }}
        //                     startDate={startYear}
        //                     endDate={endYear}
        //                     selectsRange
        //                     showYearPicker
        //                     dateFormat="yyyy"
        //                     placeholderText="Select Year Range"
        //                     className="form-control"
        //                 />

        //                 {startYear && endYear && (
        //                     <p>
        //                         Selected Range: {startYear.getFullYear()} - {endYear.getFullYear()}
        //                     </p>
        //                 )}
        //             </Col>
        //         </Row>

        //         <MaterialReactTable
        //             data={ledgerData || []}
        //             columns={financialColumns || []}
        //             enableGlobalFilter={false}
        //             initialState={{ showColumnFilters: false, density: "compact" }}
        //             positionToolbarAlertBanner="bottom"
        //             defaultColumn={{
        //                 maxSize: 400,
        //                 minSize: 80,
        //                 size: 100,
        //             }}
        //             renderTopToolbarCustomActions={({ table }) => (
        //                 <Box
        //                     sx={{
        //                         display: "flex",
        //                         gap: "0.3rem",
        //                         p: "0.5rem",
        //                         flexWrap: "wrap",
        //                     }}
        //                 >
        //                     <GetButtons onClick={fetchLedgerData} type="refresh" />
        //                     <GetExport
        //                         columns={financialColumns}
        //                         exportedData={exportedFinancialData}
        //                         name="Document"
        //                     />
        //                 </Box>

        //             )}
        //             columnResizeMode="onChange" //default
        //             manualFiltering
        //             manualPagination
        //             manualSorting
        //             onColumnFiltersChange={debouncedSetColumnFilters}

        //             onGlobalFilterChange={setGlobalFilter}
        //             onPaginationChange={setPagination}
        //             onSortingChange={setSorting}
        //             muiTableBodyProps={{
        //                 sx: {
        //                     "& td": {
        //                         paddingTop: "8px",
        //                         paddingBottom: "8px",
        //                     },
        //                 },
        //             }}
        //             rowCount={count}
        //             state={{
        //                 columnFilters,
        //                 globalFilter,
        //                 isLoading,
        //                 pagination,
        //                 sorting,
        //                 showLoadingOverlay: false,
        //                 showProgressBars: isLoading
        //             }}
        //             enableFacetedValues={true}
        //         />
        //     </div>
        // </Fragment>
    );
}

export default MscLedger;